// extracted by mini-css-extract-plugin
module.exports = {"Info":"@Commons_Info__1tXvG"};